


































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import DragToRankInput from '@/tasks/components/inputs/DragToRankInput.vue';
import {VersionTaskState} from '@/tasks/types/VersionTaskState';

export const CHOICES_BY_VERSION = [
  {A: 'hexane', B: '2,3-dimethylbutane', C: 'hexane-2,3-dione', D: 'pentane-1,1-diol'},
  {A: 'octane', B: '2,5-dimethylhexane', C: '2-methylheptan-3-one', D: 'octane-2,5-diol'},
  {A: 'pentane', B: '2,2-dimethylpropane', C: 'pentan-3-one', D: 'pentan-3-ol'},
];

export default defineComponent({
  name: 'TorontoCHMB41HQuiz2Question2',
  components: {DragToRankInput, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  props: {
    taskState: {
      type: Object as PropType<VersionTaskState>,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        order: [] as string[],
      },
    };
  },
  computed: {
    seed(): number {
      return this.$inertia.getSeed();
    },
    version(): number {
      return this.taskState.getValueByName('version')?.content?.value ?? 1;
    },
    imagePrefix(): string {
      return `/img/assignments/UofT/CHMB41H/quiz-2/question-2/q2q2v${this.version}-`;
    },
    choices(): string[] {
      return seededShuffle(Object.values(CHOICES_BY_VERSION[this.version - 1]), this.seed);
    },
    images(): string[] {
      return seededShuffle(
        ['A', 'B', 'C', 'D'].map((l: string) => this.imagePrefix + 'molecule' + l + '.png'),
        this.seed
      );
    },
  },
});
